export type PaidTier = 'PRO' | 'ENTERPRISE';
export type BillingInterval = 'month' | 'year';

// Public names can change without migrating historical database tier values.
export const BILLING_PLANS = {
  HOBBY: {
    name: 'Free',
    monthly: 0,
    annual: 0,
    features: ['3 AI generations', 'Chart styling and data editing', 'Clean PNG downloads for supported charts'],
  },
  PRO: {
    name: 'Plus',
    monthly: 2000,
    annual: 19200,
    features: ['200 AI generations each month', 'Follow-up analysis and chart revisions', 'Multiple file uploads'],
  },
  ENTERPRISE: {
    name: 'Business',
    monthly: 4500,
    annual: 43200,
    features: ['Unlimited AI generations', 'Multiple file uploads', 'Everything in Plus'],
  },
} as const;
export const PAID_TIERS: PaidTier[] = ['PRO', 'ENTERPRISE'];
export const planName = (tier: keyof typeof BILLING_PLANS) => BILLING_PLANS[tier].name;
export const planAmount = (tier: PaidTier, interval: BillingInterval) =>
  interval === 'year' ? BILLING_PLANS[tier].annual : BILLING_PLANS[tier].monthly;
export const priceLookupKey = (tier: PaidTier, interval: BillingInterval) =>
  `plotsalot_${tier === 'PRO' ? 'plus' : 'business'}_${interval}_v1`;
export const formatUsd = (amount: number) => `$${amount / 100}`;

export function safeBillingReturnUrl(value: unknown, origin: string, fallback = '/chat') {
  if (typeof value !== 'string') return new URL(fallback, origin).toString();
  const url = new URL(value, origin);
  if (url.origin !== new URL(origin).origin || url.username || url.password)
    throw new Error('Return URL must stay on this site');
  url.hash = '';
  return url.toString();
}

// Anchor monthly allowances to the subscription date, including short months.
export function monthlyAllowanceStart(start: Date, now = new Date()) {
  const anchor = (month: number) => {
    const date = new Date(start);
    date.setUTCDate(1);
    date.setUTCFullYear(now.getUTCFullYear(), month);
    const lastDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
    date.setUTCDate(Math.min(start.getUTCDate(), lastDay));
    return date;
  };
  const candidate = anchor(now.getUTCMonth());
  return candidate > now ? anchor(now.getUTCMonth() - 1) : candidate;
}
